<script setup>
import { ref } from 'vue'
import * as z from 'zod'
import { toTypedSchema } from '@vee-validate/zod'
import { HOST, API } from '@/utils/http'

import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { toast } from '@/components/ui/toast'
import { Spinner } from '@/components/ui/spinner'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

const emit = defineEmits(['formSubmitted'])
const props = defineProps({
  orgId: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  }
})

const isSubmitting = ref(false)

const radarList = ref([{
  id: 32,
  name: 'Costa Rica',
}])

const formSchema = toTypedSchema(z.object({
  radar: z.string().min(1),
}))

const postLayer = async (layer) => {
  try {
    const response = await API({
      method: 'POST',
      url: `${HOST}/layers`,
      data: layer
    })

    toast({ title: 'Layer created successfully' })
    emit('formSubmitted', response.data)

  } catch (error) {
    console.error(error)
  }
}

const onSubmit = async (values) => {
  isSubmitting.value = true

  const layer = {
    org_id: parseInt(props.orgId),
    type: 3,
    name: props.name,
    layer: {
      radar_id: parseInt(values.radar),
    }
  }

  await postLayer(layer)
  try {
    console.log(values)
    isSubmitting.value = false
  } catch (error) {
    console.error(error)
    toast({ title: 'Error creating radar layer', status: 'error' })
    isSubmitting.value = false
  }
}

</script>

<template>
  <Form class="space-y-4 mt-4" :validation-schema="formSchema" @submit="onSubmit">
    <FormField v-slot="{ componentField }" name="radar">
      <FormItem>
        <FormLabel>Radar</FormLabel>
        <FormControl>
          <Select v-bind="componentField">
            <SelectTrigger>
              <SelectValue placeholder="Select a radar" />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem
                  v-for="radar in radarList"
                  :key="radar.id"
                  :value="radar.id.toString()"
                >
                  {{ radar.name }}
                </SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>

    <div class="flex justify-end">
      <Button type="submit" :disabled="isSubmitting">
        <Spinner v-if="isSubmitting" class="w-4 h-4" />
        <span v-else>Create Layer</span>
      </Button>
    </div>
  </Form>
</template>